module.exports = __webpack_public_path__ + "static/img/250_TO8_2236_og.190ade5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/250_TO8_2236_og.jpg
// module id = O5iq
// module chunks = 0